import { STATUS_LOADING } from 'const/index';

export const selectIsWaibiLoading = (state) =>
  state.dashboardIndicators?.status === STATUS_LOADING || false;
